export const NavData = [
  { activeTab: 1, iconName: "fa-user", tittle: "Sale Lead Info" },
  { activeTab: 2, iconName: "fa-chain-broken", tittle: "Customer Info" },
  { activeTab: 3, iconName: "fa-group", tittle: "Vehicle Details" },
  // { activeTab: 4, iconName: "fa-chain-broken", tittle: "Services" },
  { activeTab: 4, iconName: "fa-group", tittle: "Inventory" },
  { activeTab: 5, iconName: "fa-group", tittle: "Installation" },
  { activeTab: 6, iconName: "fa-group", tittle: "Security Briefing" },
  { activeTab: 7, iconName: "fa-group", tittle: "Complete" },
];